import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const File = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_fileUpload_lazy" */
    "./file.js"
  )
);
const FileRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(File, { node, nodeIndex, NodeViewContainer, ...props });
};
const FileLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(FileRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.FILE]: FileLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
